export default "__VITE_ASSET__C_Dyscj3__"